import HomePage from 'components/Home/HomePage';
import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';




function Home() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <HomePage />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <HomePage />
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default Home;



